import { Suspense } from 'react'
import { Outlet } from 'react-router'
import { Sidebar } from '@/components/sidebar/Sidebar'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import { RouteFallback } from '@/components/RouteFallback'
import { useMobileMenu } from '@/hooks/useMobileMenu'
import { Bot, Menu } from 'lucide-react'
import { useAuthStore } from '@/stores/auth'

export function AppLayout() {
  const [mobileMenuOpen, setMobileMenuOpen] = useMobileMenu()
  const { activeOrg } = useAuthStore()

  return (
    <div className="flex min-h-screen bg-bg-base">
      {/* Mobile top bar — visible below md */}
      <div className="fixed top-0 left-0 right-0 z-40 flex items-center gap-3 px-4 py-3 bg-sidebar-bg border-b border-border md:hidden">
        <button
          onClick={() => setMobileMenuOpen(true)}
          className="flex items-center justify-center w-10 h-10 rounded-[var(--radius-sm)] hover:bg-sidebar-hover transition-colors"
          aria-label="Open menu"
        >
          <Menu className="w-5 h-5 text-text-secondary" />
        </button>
        <div className="w-7 h-7 rounded-[var(--radius-sm)] bg-accent-muted flex items-center justify-center shrink-0">
          <Bot className="w-3.5 h-3.5 text-accent" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-semibold text-sm tracking-tight text-text-primary truncate">
            {activeOrg?.name ?? 'Relay Agent'}
          </div>
        </div>
      </div>

      <Sidebar mobileOpen={mobileMenuOpen} onMobileClose={() => setMobileMenuOpen(false)} />

      <main className="flex-1 overflow-auto bg-geometric">
        {/* Add top padding on mobile for the fixed top bar */}
        <div className="p-4 pt-[72px] md:p-8 md:pt-8 max-w-[1440px] mx-auto">
          <ErrorBoundary>
            <Suspense fallback={<RouteFallback />}>
              <Outlet />
            </Suspense>
          </ErrorBoundary>
        </div>
      </main>
    </div>
  )
}
